import React, { useEffect, useState } from 'react';
import { 
  getBaseMaag, 
  createBaseMaagPrestation, 
  updateBaseMaagPrestation, 
  deleteBaseMaagPrestation,
  getLots,
  getDevisTypesGlobal,
  toggleLotInDevisTypeGlobal,
  getDevisTypeGlobalPrestations,
  togglePrestationInDevisTypeGlobal,
  updatePrestationInDevisTypeGlobal,
  removePrestationFromDevisTypeGlobal,
  getSousLots,
  createSousLot,
  updateSousLot,
  deleteSousLot,
  getBaseFournisseursDirects,
  createBaseFournisseurDirect,
  updateBaseFournisseurDirect,
  deleteBaseFournisseurDirect,
  getEnseignes
} from '../services/api';
import axios from 'axios';
const BACKEND = process.env.REACT_APP_BACKEND_URL;
import { 
  Database, 
  Plus, 
  Edit2, 
  Trash2, 
  ChevronDown, 
  ChevronRight,
  Save,
  X,
  Package,
  FileText,
  Check,
  Loader2,
  AlertTriangle,
  Layers,
  FolderPlus,
  GripVertical,
  Truck,
  Copy,
  Sparkles
} from 'lucide-react';
import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core';
import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  useSortable,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { toast } from 'sonner';
import AIDescriptionButton from '../components/AIDescriptionButton';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';

const TYPES_DEVIS = [
  { code: "travaux_centre_ville", nom: "Travaux centre-ville" },
  { code: "travaux_centre_commercial", nom: "Travaux centre commercial" },
  { code: "maintenance", nom: "Maintenance" },
  { code: "bureau_etude", nom: "Bureau d'étude" },
];

const LOTS_MAAG = [
  { id: "1", nom: "PILOTAGE DES INTERVENANTS DIRECTS / BUREAU D'ETUDE" },
  { id: "2", nom: "GARDIENNAGE" },
  { id: "3", nom: "PALISSADE" },
  { id: "4", nom: "DEPOSE / DÉMOLITION" },
  { id: "5", nom: "MAÇONNERIE" },
  { id: "6", nom: "PROTECTION COUPE FEU" },
  { id: "7", nom: "VITRINE FACADE HABILLAGE" },
  { id: "8", nom: "SERRURERIE" },
  { id: "9", nom: "DOUBLAGE - CLOISONNEMENT - FAUX-PLAFOND" },
  { id: "10", nom: "PEINTURE" },
  { id: "11", nom: "REVETEMENT DE SOL" },
  { id: "12", nom: "ELECTRICITE" },
  { id: "13", nom: "CLIMATISATION - RAC - VMC" },
  { id: "14", nom: "PLOMBERIE SANITAIRES" },
  { id: "15", nom: "MENUISERIE - POSE MOBILIER" },
  { id: "16", nom: "SECURITE INCENDIE" },
  { id: "17", nom: "NETTOYAGE" },
  { id: "18", nom: "REMISE COMMERCIAL" }
];

// Sortable sous-lot component for drag and drop
const SortableSousLot = ({ sousLot, lotId, expandedSousLots, toggleSousLot, openCreateModal, openSousLotModal, handleDeleteSousLot, selectedPrestations, toggleSelectPrestation, openEditModal, handleDelete, openDuplicateModal }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: sousLot.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <div ref={setNodeRef} style={style} className="border border-purple-200 rounded-lg overflow-hidden bg-purple-50/50">
      {/* Sous-lot header */}
      <div className="flex items-center justify-between px-4 py-3 hover:bg-purple-100/50 transition-colors">
        <div className="flex items-center gap-2">
          <button {...attributes} {...listeners} className="cursor-grab active:cursor-grabbing p-1 text-purple-400 hover:text-purple-600">
            <GripVertical className="w-4 h-4" />
          </button>
          <button onClick={() => toggleSousLot(sousLot.id)} className="flex items-center gap-2">
            {expandedSousLots[sousLot.id] ? (
              <ChevronDown className="w-4 h-4 text-purple-500" />
            ) : (
              <ChevronRight className="w-4 h-4 text-purple-500" />
            )}
            <Layers className="w-4 h-4 text-purple-600" />
            <span className="font-semibold text-purple-900">{sousLot.nom}</span>
          </button>
          <span className="text-xs text-purple-600 bg-purple-200 px-2 py-0.5 rounded-full">
            {sousLot.prestations?.length || 0} prestation{(sousLot.prestations?.length || 0) !== 1 ? 's' : ''}
          </span>
        </div>
        <div className="flex items-center gap-2">
          <button
            onClick={() => openCreateModal(lotId, sousLot.id)}
            className="p-1.5 text-purple-600 hover:bg-purple-200 rounded"
            title="Ajouter une prestation"
          >
            <Plus className="w-4 h-4" />
          </button>
          <button
            onClick={() => openSousLotModal(lotId, sousLot)}
            className="p-1.5 text-purple-600 hover:bg-purple-200 rounded"
            title="Modifier le sous-lot"
          >
            <Edit2 className="w-4 h-4" />
          </button>
          <button
            onClick={() => handleDeleteSousLot(sousLot.id, sousLot.nom)}
            className="p-1.5 text-red-500 hover:bg-red-100 rounded"
            title="Supprimer le sous-lot"
          >
            <Trash2 className="w-4 h-4" />
          </button>
        </div>
      </div>
      
      {/* Sous-lot prestations */}
      {expandedSousLots[sousLot.id] && sousLot.prestations && sousLot.prestations.length > 0 && (
        <div className="px-4 pb-3 bg-white">
          <table className="w-full">
            <tbody className="divide-y divide-slate-100">
              {sousLot.prestations.map((prestation) => (
                <tr key={prestation.id} className="hover:bg-slate-50">
                  <td className="w-10 py-2 px-2">
                    <input
                      type="checkbox"
                      checked={selectedPrestations.has(prestation.id)}
                      onChange={() => toggleSelectPrestation(prestation.id)}
                      className="w-4 h-4 rounded border-slate-300 text-indigo-600 focus:ring-indigo-500"
                    />
                  </td>
                  <td className="py-2 px-2">
                    <span className="font-mono text-xs bg-slate-100 px-2 py-1 rounded">{prestation.code}</span>
                  </td>
                  <td className="py-2 px-2">
                    <p className="font-medium text-sm">{prestation.designation}</p>
                  </td>
                  <td className="py-2 px-2 text-center text-xs">{prestation.unite}</td>
                  <td className="py-2 px-2 text-center text-sm">{prestation.quantite_defaut || 0}</td>
                  <td className="py-2 px-2 text-right text-sm font-medium text-indigo-600">
                    {(prestation.prix_maag || 0).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' })}
                  </td>
                  <td className="py-2 px-2 text-right">
                    <div className="flex justify-end gap-1">
                      <button
                        onClick={() => openDuplicateModal(prestation, lotId)}
                        className="p-1.5 text-slate-400 hover:text-emerald-600 hover:bg-emerald-50 rounded"
                        title="Dupliquer cet article"
                        data-testid={`duplicate-sl-${prestation.id}`}
                      >
                        <Copy className="w-4 h-4" />
                      </button>
                      <button onClick={() => openEditModal(prestation, lotId)} className="p-1.5 text-slate-400 hover:text-indigo-600 hover:bg-indigo-50 rounded">
                        <Edit2 className="w-4 h-4" />
                      </button>
                      <button onClick={() => handleDelete(prestation.id)} className="p-1.5 text-slate-400 hover:text-red-600 hover:bg-red-50 rounded">
                        <Trash2 className="w-4 h-4" />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      
      {/* Empty sous-lot */}
      {expandedSousLots[sousLot.id] && (!sousLot.prestations || sousLot.prestations.length === 0) && (
        <div className="px-4 pb-3 bg-white">
          <p className="text-sm text-slate-500 italic py-2">Aucune prestation dans ce sous-lot</p>
        </div>
      )}
    </div>
  );
};

const BaseMaagPage = () => {
  const [activeTab, setActiveTab] = useState('prestations'); // 'prestations', 'devis-types', or 'fournisseurs-directs'
  const [loading, setLoading] = useState(true);
  const [baseMaag, setBaseMaag] = useState([]);
  const [lots, setLots] = useState([]);
  const [expandedLots, setExpandedLots] = useState({});
  const [expandedSousLots, setExpandedSousLots] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [editingPrestation, setEditingPrestation] = useState(null);
  const [formData, setFormData] = useState({
    lot_id: '1',
    sous_lot_id: '',
    code: '',
    designation: '',
    description: '',
    unite: 'U',
    quantite_defaut: 0,
    prix_maag: 0,
    enseigne_id: '' // '' = MAAG commun, else enseigne UUID
  });
  const [enseignesList, setEnseignesList] = useState([]);
  const [previewCode, setPreviewCode] = useState('');
  const [lotFilter, setLotFilter] = useState(''); // '' = tous les lots, sinon id du lot
  
  // Sous-lots par défaut manager
  const [showSousLotsManager, setShowSousLotsManager] = useState(false);
  const [sousLotsManagerLotId, setSousLotsManagerLotId] = useState('12');
  const [sousLotsManagerList, setSousLotsManagerList] = useState([]);
  const [sousLotsManagerNew, setSousLotsManagerNew] = useState('');
  const [sousLotsManagerLoading, setSousLotsManagerLoading] = useState(false);
  
  const loadSousLotsManager = async (lotId) => {
    setSousLotsManagerLoading(true);
    try {
      const token = localStorage.getItem('token');
      const API = process.env.REACT_APP_BACKEND_URL;
      const r = await axios.get(`${API}/api/sous-lots-templates?lot_id=${lotId}`, { headers: { Authorization: `Bearer ${token}` } });
      setSousLotsManagerList(r.data || []);
    } catch (e) { setSousLotsManagerList([]); } finally { setSousLotsManagerLoading(false); }
  };
  
  useEffect(() => {
    if (showSousLotsManager) loadSousLotsManager(sousLotsManagerLotId);
  }, [showSousLotsManager, sousLotsManagerLotId]);
  
  const addSousLotTemplate = async () => {
    const nom = sousLotsManagerNew.trim();
    if (!nom) return;
    const token = localStorage.getItem('token');
    const API = process.env.REACT_APP_BACKEND_URL;
    try {
      await axios.post(`${API}/api/sous-lots-templates`, { lot_id: sousLotsManagerLotId, nom }, { headers: { Authorization: `Bearer ${token}` } });
      setSousLotsManagerNew('');
      loadSousLotsManager(sousLotsManagerLotId);
      toast.success('Sous-lot ajouté');
    } catch (e) { toast.error("Échec ajout"); }
  };
  
  const updateSousLotTemplate = async (id, nom) => {
    const token = localStorage.getItem('token');
    const API = process.env.REACT_APP_BACKEND_URL;
    try {
      await axios.put(`${API}/api/sous-lots-templates/${id}`, { nom }, { headers: { Authorization: `Bearer ${token}` } });
      loadSousLotsManager(sousLotsManagerLotId);
      toast.success('Mis à jour');
    } catch (e) { toast.error("Échec mise à jour"); }
  };
  
  const deleteSousLotTemplate = async (id) => {
    if (!window.confirm("Supprimer ce sous-lot par défaut ? Les devis existants ne seront pas affectés.")) return;
    const token = localStorage.getItem('token');
    const API = process.env.REACT_APP_BACKEND_URL;
    try {
      await axios.delete(`${API}/api/sous-lots-templates/${id}`, { headers: { Authorization: `Bearer ${token}` } });
      loadSousLotsManager(sousLotsManagerLotId);
    } catch (e) { toast.error("Échec suppression"); }
  };

  // ==================== Groupements Manager (per lot) ====================
  const [showGroupementsManager, setShowGroupementsManager] = useState(false);
  const [groupementsManagerLotId, setGroupementsManagerLotId] = useState(null);
  const [groupementsList, setGroupementsList] = useState([]);
  const [groupementsLoading, setGroupementsLoading] = useState(false);
  const [editingGroupement, setEditingGroupement] = useState(null); // null = creation modal closed, object = edit/create
  const [expandedGroupements, setExpandedGroupements] = useState({});

  const loadGroupements = async (lotId) => {
    setGroupementsLoading(true);
    try {
      const token = localStorage.getItem('token');
      const API = process.env.REACT_APP_BACKEND_URL;
      const r = await axios.get(`${API}/api/groupes-templates?lot_id=${lotId}&scope=all`, { headers: { Authorization: `Bearer ${token}` } });
      setGroupementsList(r.data || []);
    } catch (e) { setGroupementsList([]); } finally { setGroupementsLoading(false); }
  };

  const openGroupementsManager = (lotId) => {
    setGroupementsManagerLotId(lotId);
    setShowGroupementsManager(true);
  };

  useEffect(() => {
    if (showGroupementsManager && groupementsManagerLotId) loadGroupements(groupementsManagerLotId);
  }, [showGroupementsManager, groupementsManagerLotId]);

  const saveGroupement = async (tpl) => {
    const token = localStorage.getItem('token');
    const API = process.env.REACT_APP_BACKEND_URL;
    const payload = {
      nom: (tpl.nom || '').trim(),
      description: tpl.description || '',
      lot_id: tpl.lot_id || groupementsManagerLotId,
      sous_lot_nom: tpl.sous_lot_nom || null,
      sous_sous_lot_nom: tpl.sous_sous_lot_nom || null,
      scope: tpl.enseigne_id ? 'enseigne' : 'global',
      enseigne_id: tpl.enseigne_id || null,
      lignes: (tpl.lignes || []).map(l => ({
        designation: (l.designation || l.description || '').trim(),
        description: l.description || '',
        unite: l.unite || 'U',
        quantite: parseFloat(l.quantite) || 0,
        prix_unitaire: parseFloat(l.prix_unitaire) || 0,
      })),
    };
    if (!payload.nom) { toast.error('Nom requis'); return false; }
    // designation is required by backend — block save if any line is missing it
    const missingDesignation = payload.lignes.some(l => !l.designation);
    if (missingDesignation) { toast.error('Chaque ligne doit avoir une désignation'); return false; }
    try {
      if (tpl.id) {
        await axios.put(`${API}/api/groupes-templates/${tpl.id}`, payload, { headers: { Authorization: `Bearer ${token}` } });
        toast.success('Groupement mis à jour');
      } else {
        await axios.post(`${API}/api/groupes-templates`, payload, { headers: { Authorization: `Bearer ${token}` } });
        toast.success('Groupement créé');
      }
      loadGroupements(groupementsManagerLotId);
      return true;
    } catch (e) {
      toast.error('Erreur sauvegarde');
      return false;
    }
  };

  const duplicateGroupement = async (tpl) => {
    const copy = {
      ...tpl,
      id: null,
      nom: `${tpl.nom} (copie)`,
    };
    const ok = await saveGroupement(copy);
    if (ok) toast.success('Groupement dupliqué');
  };

  const deleteGroupement = async (id) => {
    if (!window.confirm('Supprimer ce groupement ? Action irréversible.')) return;
    const token = localStorage.getItem('token');
    const API = process.env.REACT_APP_BACKEND_URL;
    try {
      await axios.delete(`${API}/api/groupes-templates/${id}`, { headers: { Authorization: `Bearer ${token}` } });
      toast.success('Supprimé');
      loadGroupements(groupementsManagerLotId);
    } catch (e) { toast.error('Échec suppression'); }
  };
  // ==================== End Groupements Manager ====================

  const [savingPrestation, setSavingPrestation] = useState(false);
  
  // Sous-lots state
  const [sousLots, setSousLots] = useState([]);
  const [showSousLotModal, setShowSousLotModal] = useState(false);
  const [editingSousLot, setEditingSousLot] = useState(null);
  const [sousLotFormData, setSousLotFormData] = useState({
    lot_id: '',
    nom: '',
    ordre: 0
  });
  
  // Selection state for bulk delete
  const [selectedPrestations, setSelectedPrestations] = useState(new Set());
  const [isDeleting, setIsDeleting] = useState(false);
  
  // Inline editing state
  const [inlineEditing, setInlineEditing] = useState(null); // {id, field, value}
  const [savingInline, setSavingInline] = useState(false);
  
  // Devis Types state
  const [devisTypesConfig, setDevisTypesConfig] = useState({});
  const [loadingDevisTypes, setLoadingDevisTypes] = useState(false);
  const [selectedDevisType, setSelectedDevisType] = useState(null);
  const [devisTypePrestations, setDevisTypePrestations] = useState([]);
  const [expandedDevisTypeLots, setExpandedDevisTypeLots] = useState({});
  const [editingDevisTypePrestation, setEditingDevisTypePrestation] = useState(null);
  
  // Modal pour ajouter des prestations au devis type
  const [showAddPrestationsModal, setShowAddPrestationsModal] = useState(false);
  const [prestationsToAdd, setPrestationsToAdd] = useState(new Set());
  const [addingPrestations, setAddingPrestations] = useState(false);
  
  // Fournisseurs Directs state
  const [baseFournisseursDirects, setBaseFournisseursDirects] = useState([]);
  const [newFDDesignation, setNewFDDesignation] = useState('');
  const [newFDCategorie, setNewFDCategorie] = useState('intervenants');

  const unites = ['U', 'M²', 'ML', 'H', 'FORFAIT'];
  const categoriesFD = [
    { value: 'intervenants', label: 'Intervenants Mandatés' },
    { value: 'fournitures', label: 'Fournitures Client' },
    { value: 'divers', label: 'Divers' }
  ];

  useEffect(() => {
    loadData();
    getEnseignes().then(res => setEnseignesList(res.data || [])).catch(() => {});
  }, []);

  // Preview the auto-generated code whenever the scope changes inside the create modal
  useEffect(() => {
    if (!showModal || editingPrestation) { setPreviewCode(''); return; }
    if (!formData.lot_id) { setPreviewCode(''); return; }
    const token = localStorage.getItem('token');
    const params = new URLSearchParams({ lot_id: formData.lot_id });
    if (formData.enseigne_id) params.set('enseigne_id', formData.enseigne_id);
    axios.get(`${BACKEND}/api/base-maag/next-code?${params.toString()}`, {
      headers: { Authorization: `Bearer ${token}` }
    }).then(res => setPreviewCode(res.data.code || ''))
      .catch(() => setPreviewCode(''));
  }, [showModal, editingPrestation, formData.lot_id, formData.enseigne_id]);

  useEffect(() => {
    if (activeTab === 'devis-types') {
      loadDevisTypesConfig();
    } else if (activeTab === 'fournisseurs-directs') {
      loadFournisseursDirects();
    }
  }, [activeTab]);

  const loadData = async (preserveExpanded = false) => {
    try {
      setLoading(true);
      const [baseMaagRes, lotsRes, sousLotsRes] = await Promise.all([
        getBaseMaag(),
        getLots(),
        getSousLots()
      ]);
      setBaseMaag(baseMaagRes.data);
      setLots(lotsRes.data);
      setSousLots(sousLotsRes.data);
      
      // Expand all lots by default on first load; preserve user's state on reload
      if (!preserveExpanded) {
        const expanded = {};
        lotsRes.data.forEach(lot => {
          expanded[lot.id] = true;
        });
        setExpandedLots(expanded);
      }
    } catch (err) {
      toast.error('Erreur lors du chargement');
    } finally {
      setLoading(false);
    }
  };
  
  const loadFournisseursDirects = async () => {
    try {
      const res = await getBaseFournisseursDirects();
      setBaseFournisseursDirects(res.data);
    } catch (err) {
      toast.error('Erreur lors du chargement des fournisseurs directs');
    }
  };
  
  const handleAddFournisseurDirect = async () => {
    if (!newFDDesignation.trim()) {
      toast.error('La désignation est requise');
      return;
    }
    try {
      await createBaseFournisseurDirect({
        designation: newFDDesignation.trim(),
        categorie: newFDCategorie
      });
      setNewFDDesignation('');
      setNewFDCategorie('intervenants');
      loadFournisseursDirects();
      toast.success('Fournisseur direct ajouté');
    } catch (err) {
      toast.error('Erreur lors de l\'ajout');
    }
  };
  
  const handleUpdateFournisseurDirect = async (fdId, field, value) => {
    try {
      await updateBaseFournisseurDirect(fdId, { [field]: value });
      loadFournisseursDirects();
      toast.success('Mis à jour');
    } catch (err) {
      toast.error('Erreur');
    }
  };
  
  const handleDeleteFournisseurDirect = async (fdId) => {
    if (!window.confirm('Supprimer ce fournisseur direct ?')) return;
    try {
      await deleteBaseFournisseurDirect(fdId);
      loadFournisseursDirects();
      toast.success('Supprimé');
    } catch (err) {
      toast.error('Erreur');
    }
  };

  const loadDevisTypesConfig = async () => {
    try {
      setLoadingDevisTypes(true);
      const res = await getDevisTypesGlobal();
      setDevisTypesConfig(res.data);
      if (!selectedDevisType && TYPES_DEVIS.length > 0) {
        setSelectedDevisType(TYPES_DEVIS[0].code);
      }
    } catch (err) {
      toast.error('Erreur chargement config devis types');
    } finally {
      setLoadingDevisTypes(false);
    }
  };

  const loadDevisTypePrestations = async (typeCode) => {
    try {
      setLoadingDevisTypes(true);
      const res = await getDevisTypeGlobalPrestations(typeCode);
      setDevisTypePrestations(res.data);
    } catch (err) {
      toast.error('Erreur chargement des prestations');
    } finally {
      setLoadingDevisTypes(false);
    }
  };

  useEffect(() => {
    if (selectedDevisType) {
      loadDevisTypePrestations(selectedDevisType);
    }
  }, [selectedDevisType]);

  const handleToggleLotGlobal = async (lotId, typeCode) => {
    const currentConfig = devisTypesConfig[typeCode]?.lots || {};
    const isActive = currentConfig[lotId] !== false;
    
    try {
      await toggleLotInDevisTypeGlobal(typeCode, lotId, !isActive);
      toast.success(`Lot ${isActive ? 'désactivé' : 'activé'} pour TOUTES les enseignes`);
      await loadDevisTypesConfig();
      await loadDevisTypePrestations(typeCode);
    } catch (err) {
      toast.error('Erreur');
    }
  };

  const handleTogglePrestationGlobal = async (prestationId, currentActif) => {
    try {
      await togglePrestationInDevisTypeGlobal(selectedDevisType, prestationId, !currentActif);
      toast.success(`Prestation ${currentActif ? 'désactivée' : 'activée'} pour TOUTES les enseignes`);
      await loadDevisTypePrestations(selectedDevisType);
    } catch (err) {
      toast.error('Erreur');
    }
  };

  const handleSaveDevisTypePrestation = async () => {
    if (!editingDevisTypePrestation) return;
    try {
      await updatePrestationInDevisTypeGlobal(selectedDevisType, editingDevisTypePrestation.id, {
        prix_defaut: editingDevisTypePrestation.prix_defaut,
        description_override: editingDevisTypePrestation.description_override,
        quantite_defaut: editingDevisTypePrestation.quantite_defaut
      });
      toast.success('Prestation mise à jour pour TOUTES les enseignes');
      setEditingDevisTypePrestation(null);
      await loadDevisTypePrestations(selectedDevisType);
    } catch (err) {
      toast.error('Erreur');
    }
  };

  const handleRemovePrestationGlobal = async (prestationId, designation) => {
    if (!window.confirm(`Désactiver "${designation}" pour TOUTES les enseignes ?`)) return;
    try {
      await removePrestationFromDevisTypeGlobal(selectedDevisType, prestationId);
      toast.success('Prestation désactivée pour TOUTES les enseignes');
      await loadDevisTypePrestations(selectedDevisType);
    } catch (err) {
      toast.error('Erreur');
    }
  };

  const toggleDevisTypeLot = (lotId) => {
    setExpandedDevisTypeLots(prev => ({ ...prev, [lotId]: !prev[lotId] }));
  };

  const getPrestationsByLot = (lotId) => {
    return devisTypePrestations.filter(p => p.lot_id === lotId);
  };

  const getActivePrestationsCount = (lotId) => {
    return devisTypePrestations.filter(p => p.lot_id === lotId && p.actif).length;
  };

  const isLotActiveInType = (lotId, typeCode) => {
    const config = devisTypesConfig[typeCode];
    if (!config || !config.lots) return true;
    return config.lots[lotId] !== false;
  };

  const toggleLot = (lotId) => {
    setExpandedLots(prev => ({
      ...prev,
      [lotId]: !prev[lotId]
    }));
  };

  const openCreateModal = (lotId = '1', sousLotId = '') => {
    setEditingPrestation(null);
    setFormData({
      lot_id: lotId,
      sous_lot_id: sousLotId,
      code: '',
      designation: '',
      description: '',
      unite: 'U',
      quantite_defaut: 0,
      prix_maag: 0,
      enseigne_id: ''
    });
    setShowModal(true);
  };

  const openEditModal = (prestation, lotId) => {
    setEditingPrestation(prestation);
    setFormData({
      lot_id: lotId,
      sous_lot_id: prestation.sous_lot_id || '',
      code: prestation.code,
      designation: prestation.designation,
      description: prestation.description,
      unite: prestation.unite,
      quantite_defaut: prestation.quantite_defaut || 0,
      prix_maag: prestation.prix_maag || 0,
      enseigne_id: prestation.enseigne_id || ''
    });
    setShowModal(true);
  };

  const openDuplicateModal = (prestation, lotId) => {
    // Crée un nouvel article pré-rempli à partir d'un existant
    setEditingPrestation(null);
    setFormData({
      lot_id: lotId,
      sous_lot_id: prestation.sous_lot_id || '',
      code: '',
      designation: `${prestation.designation} (copie)`,
      description: prestation.description || '',
      unite: prestation.unite || 'U',
      quantite_defaut: prestation.quantite_defaut || 0,
      prix_maag: prestation.prix_maag || 0,
      enseigne_id: prestation.enseigne_id || ''
    });
    setShowModal(true);
  };

  const handleSubmit = async (e, keepOpenForAnother = false) => {
    if (e?.preventDefault) e.preventDefault();
    if (savingPrestation) return;
    setSavingPrestation(true);
    try {
      // Auto-set quantite to 1 for FORFAIT if not specified
      let quantite = formData.quantite_defaut;
      if (quantite === 0 && formData.unite.toUpperCase() === 'FORFAIT') {
        quantite = 1;
      }
      
      if (editingPrestation) {
        await updateBaseMaagPrestation(editingPrestation.id, {
          designation: formData.designation,
          description: formData.description,
          unite: formData.unite,
          quantite_defaut: quantite,
          prix_maag: formData.prix_maag,
          sous_lot_id: formData.sous_lot_id || null,
          enseigne_id: formData.enseigne_id || ''
        });
        toast.success('Prestation mise à jour');
      } else {
        await createBaseMaagPrestation({
          lot_id: formData.lot_id,
          sous_lot_id: formData.sous_lot_id || null,
          designation: formData.designation,
          description: formData.description,
          unite: formData.unite,
          quantite_defaut: quantite,
          prix_maag: formData.prix_maag,
          enseigne_id: formData.enseigne_id || null
        });
        toast.success('Prestation ajoutée');
      }
      // Reload data but preserve the user's expanded-lot state
      loadData(true);
      
      if (keepOpenForAnother && !editingPrestation) {
        // Keep same lot / sous_lot / enseigne / unit / prix — reset only the textual fields
        setFormData(prev => ({
          ...prev,
          designation: '',
          description: ''
        }));
      } else {
        setShowModal(false);
      }
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Erreur');
    } finally {
      setSavingPrestation(false);
    }
  };

  const handleDelete = async (prestationId) => {
    if (!window.confirm('Supprimer cette prestation de la base MAAG ?')) return;
    try {
      await deleteBaseMaagPrestation(prestationId);
      toast.success('Prestation supprimée');
      setSelectedPrestations(prev => {
        const newSet = new Set(prev);
        newSet.delete(prestationId);
        return newSet;
      });
      loadData(true);
    } catch (err) {
      toast.error('Erreur lors de la suppression');
    }
  };

  // Bulk selection handlers
  const toggleSelectPrestation = (prestationId) => {
    setSelectedPrestations(prev => {
      const newSet = new Set(prev);
      if (newSet.has(prestationId)) {
        newSet.delete(prestationId);
      } else {
        newSet.add(prestationId);
      }
      return newSet;
    });
  };

  const selectAllInLot = (lotId) => {
    const lot = baseMaag.find(l => l.lot_id === lotId);
    if (!lot?.prestations) return;
    
    const lotPrestationIds = lot.prestations.map(p => p.id);
    const allSelected = lotPrestationIds.every(id => selectedPrestations.has(id));
    
    setSelectedPrestations(prev => {
      const newSet = new Set(prev);
      if (allSelected) {
        lotPrestationIds.forEach(id => newSet.delete(id));
      } else {
        lotPrestationIds.forEach(id => newSet.add(id));
      }
      return newSet;
    });
  };

  const handleBulkDelete = async () => {
    if (selectedPrestations.size === 0) return;
    if (!window.confirm(`Supprimer ${selectedPrestations.size} prestation(s) sélectionnée(s) ?`)) return;
    
    setIsDeleting(true);
    try {
      for (const prestationId of selectedPrestations) {
        await deleteBaseMaagPrestation(prestationId);
      }
      toast.success(`${selectedPrestations.size} prestation(s) supprimée(s)`);
      setSelectedPrestations(new Set());
      loadData(true);
    } catch (err) {
      toast.error('Erreur lors de la suppression');
    } finally {
      setIsDeleting(false);
    }
  };

  // Inline editing handlers
  const startInlineEdit = (prestationId, field, currentValue) => {
    setInlineEditing({ id: prestationId, field, value: currentValue });
  };

  const cancelInlineEdit = () => {
    setInlineEditing(null);
  };

  const saveInlineEdit = async (prestationId, lotId) => {
    if (!inlineEditing) return;
    
    setSavingInline(true);
    try {
      const lot = baseMaag.find(l => l.lot_id === lotId);
      const prestation = lot?.prestations?.find(p => p.id === prestationId);
      if (!prestation) return;
      
      const updateData = {
        lot_id: lotId,
        code: prestation.code,
        designation: prestation.designation,
        description: prestation.description,
        unite: inlineEditing.field === 'unite' ? inlineEditing.value : prestation.unite,
        quantite_defaut: inlineEditing.field === 'quantite_defaut' ? parseFloat(inlineEditing.value) || 0 : prestation.quantite_defaut,
        prix_maag: inlineEditing.field === 'prix_maag' ? parseFloat(inlineEditing.value) || 0 : prestation.prix_maag
      };
      
      await updateBaseMaagPrestation(prestationId, updateData);
      toast.success('Modifié');
      setInlineEditing(null);
      loadData(true);
    } catch (err) {
      toast.error('Erreur');
    } finally {
      setSavingInline(false);
    }
  };

  const getPrestationCount = (lotId) => {
    const lot = baseMaag.find(l => l.lot_id === lotId);
    // Count direct prestations + prestations in sous-lots
    const directCount = lot?.prestations?.length || 0;
    const sousLotsCount = (lot?.sous_lots || []).reduce((acc, sl) => acc + (sl.prestations?.length || 0), 0);
    return directCount + sousLotsCount;
  };

  // Sous-lots functions
  const toggleSousLot = (sousLotId) => {
    setExpandedSousLots(prev => ({
      ...prev,
      [sousLotId]: !prev[sousLotId]
    }));
  };

  const openSousLotModal = (lotId, sousLot = null) => {
    setEditingSousLot(sousLot);
    setSousLotFormData({
      lot_id: lotId,
      nom: sousLot?.nom || '',
      ordre: sousLot?.ordre || 0
    });
    setShowSousLotModal(true);
  };

  const handleSousLotSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingSousLot) {
        await updateSousLot(editingSousLot.id, {
          nom: sousLotFormData.nom,
          ordre: sousLotFormData.ordre
        });
        toast.success('Sous-lot mis à jour');
      } else {
        await createSousLot(sousLotFormData);
        toast.success('Sous-lot créé');
      }
      setShowSousLotModal(false);
      loadData(true);
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Erreur');
    }
  };

  const handleDeleteSousLot = async (sousLotId, nom) => {
    if (!window.confirm(`Supprimer le sous-lot "${nom}" ? Les prestations associées seront déplacées au niveau du lot.`)) return;
    try {
      await deleteSousLot(sousLotId);
      toast.success('Sous-lot supprimé');
      loadData(true);
    } catch (err) {
      toast.error('Erreur lors de la suppression');
    }
  };

  const getSousLotsForLot = (lotId) => {
    const lot = baseMaag.find(l => l.lot_id === lotId);
    return lot?.sous_lots || [];
  };

  // Drag and drop sensors
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 8,
      },
    }),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );

  // Handle drag end for sous-lots reordering
  const handleDragEnd = async (event, lotId) => {
    const { active, over } = event;
    
    if (active.id !== over?.id) {
      const lot = baseMaag.find(l => l.lot_id === lotId);
      if (!lot?.sous_lots) return;
      
      const oldIndex = lot.sous_lots.findIndex(sl => sl.id === active.id);
      const newIndex = lot.sous_lots.findIndex(sl => sl.id === over.id);
      
      if (oldIndex !== -1 && newIndex !== -1) {
        const newSousLots = arrayMove(lot.sous_lots, oldIndex, newIndex);
        
        // Update ordre for all affected sous-lots
        try {
          const updates = newSousLots.map((sl, idx) => 
            updateSousLot(sl.id, { ordre: idx })
          );
          await Promise.all(updates);
          toast.success('Ordre mis à jour');
          loadData(true);
        } catch (err) {
          toast.error('Erreur lors de la mise à jour de l\'ordre');
        }
      }
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-slate-900"></div>
      </div>
    );
  }

  return (
    <div data-testid="base-maag-page" className="space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <div className="w-12 h-12 bg-gradient-to-br from-indigo-600 to-purple-600 rounded-xl flex items-center justify-center mr-4">
            <Database className="w-6 h-6 text-white" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-slate-900">Base MAAG</h1>
            <p className="text-sm text-slate-500">Descriptifs, prestations et devis types</p>
          </div>
        </div>
        {activeTab === 'prestations' && (
          <div className="flex items-center gap-3 flex-wrap">
            {/* Lot filter */}
            <div className="flex items-center gap-2">
              <label className="text-xs font-medium text-slate-600 whitespace-nowrap">Filtrer par lot :</label>
              <select
                value={lotFilter}
                onChange={(e) => setLotFilter(e.target.value)}
                className="h-9 px-2 text-sm border border-slate-300 rounded-lg bg-white focus:outline-none focus:ring-2 focus:ring-indigo-500 max-w-[240px]"
                data-testid="lot-filter-select"
              >
                <option value="">Tous les lots</option>
                {LOTS_MAAG.map(l => (
                  <option key={l.id} value={l.id}>{l.id} – {l.nom}</option>
                ))}
              </select>
              {lotFilter && (
                <button
                  onClick={() => setLotFilter('')}
                  className="text-xs text-slate-500 hover:text-slate-700 underline"
                  data-testid="clear-lot-filter"
                >
                  Effacer
                </button>
              )}
            </div>
            {selectedPrestations.size > 0 && (
              <Button 
                onClick={handleBulkDelete} 
                disabled={isDeleting}
                className="bg-red-600 hover:bg-red-700"
              >
                {isDeleting ? (
                  <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                ) : (
                  <Trash2 className="w-4 h-4 mr-2" />
                )}
                Supprimer ({selectedPrestations.size})
              </Button>
            )}
            <Button onClick={() => openCreateModal(lotFilter || '1')} className="bg-indigo-600 hover:bg-indigo-700">
              <Plus className="w-4 h-4 mr-2" />
              Nouvelle prestation
            </Button>
            <Button
              onClick={async () => {
                if (!window.confirm("Initialiser/compléter la bibliothèque de groupements ADOPT (23 groupements Électricité : Coupures urgence, Caisse, Meuble mural...) ?\n\nLes groupements déjà existants ne seront pas dupliqués.")) return;
                const token = localStorage.getItem('token');
                const API = process.env.REACT_APP_BACKEND_URL;
                try {
                  const r = await axios.post(`${API}/api/setup/seed-adopt-groupes`, {}, { headers: { Authorization: `Bearer ${token}` } });
                  toast.success(`Bibliothèque ADOPT : ${r.data.created} nouveaux groupements, ${r.data.skipped_existing} déjà présents (${r.data.total} total)`);
                } catch (e) {
                  toast.error("Échec : " + (e.response?.data?.detail || e.message));
                }
              }}
              variant="outline"
              className="border-emerald-300 text-emerald-700 hover:bg-emerald-50"
              data-testid="seed-adopt-groupes-btn"
            >
              <Package className="w-4 h-4 mr-2" />
              Initialiser groupements ADOPT
            </Button>
            <Button
              onClick={() => setShowSousLotsManager(true)}
              variant="outline"
              className="border-blue-300 text-blue-700 hover:bg-blue-50"
              data-testid="manage-sous-lots-btn"
            >
              <Package className="w-4 h-4 mr-2" />
              Sous-lots par défaut
            </Button>
            <Button
              onClick={async () => {
                if (!window.confirm("Retraiter TOUS les articles Base MAAG via l'IA pour raccourcir les descriptions (20 mots / 2 lignes max) ?\n\nCela peut prendre plusieurs minutes selon le nombre d'articles.")) return;
                const token = localStorage.getItem('token');
                const loadingToast = toast.loading('IA en cours — raccourcissement des descriptions…');
                try {
                  const API = process.env.REACT_APP_BACKEND_URL;
                  const r = await axios.post(`${API}/api/base-maag/shorten-all`, {}, { headers: { Authorization: `Bearer ${token}` }, timeout: 600000 });
                  toast.dismiss(loadingToast);
                  toast.success(`Terminé : ${r.data.updated} mis à jour, ${r.data.skipped_already_short} déjà courts, ${r.data.failed} échecs (sur ${r.data.total}).`);
                  loadData();
                } catch (e) {
                  toast.dismiss(loadingToast);
                  toast.error("Échec du raccourcissement IA");
                }
              }}
              variant="outline"
              className="border-violet-300 text-violet-700 hover:bg-violet-50"
              data-testid="shorten-all-base-maag-btn"
            >
              <Sparkles className="w-4 h-4 mr-2" />
              Raccourcir toutes les descriptions (IA)
            </Button>
          </div>
        )}
      </div>

      {/* Selection info bar */}
      {activeTab === 'prestations' && selectedPrestations.size > 0 && (
        <div className="bg-amber-50 border border-amber-200 rounded-lg px-4 py-2 flex items-center justify-between">
          <span className="text-sm text-amber-800">
            <Check className="w-4 h-4 inline mr-2" />
            {selectedPrestations.size} prestation(s) sélectionnée(s)
          </span>
          <button 
            onClick={() => setSelectedPrestations(new Set())}
            className="text-sm text-amber-600 hover:text-amber-800"
          >
            Tout désélectionner
          </button>
        </div>
      )}

      {/* Tabs */}
      <div className="flex gap-2 border-b border-slate-200">
        <button
          onClick={() => setActiveTab('prestations')}
          className={`px-4 py-2 font-medium text-sm border-b-2 transition-colors ${
            activeTab === 'prestations'
              ? 'border-indigo-600 text-indigo-600'
              : 'border-transparent text-slate-500 hover:text-slate-700'
          }`}
        >
          <Package className="w-4 h-4 inline mr-2" />
          Prestations
        </button>
        <button
          onClick={() => setActiveTab('devis-types')}
          className={`px-4 py-2 font-medium text-sm border-b-2 transition-colors ${
            activeTab === 'devis-types'
              ? 'border-indigo-600 text-indigo-600'
              : 'border-transparent text-slate-500 hover:text-slate-700'
          }`}
        >
          <FileText className="w-4 h-4 inline mr-2" />
          Devis Types (4 modèles)
        </button>
        <button
          onClick={() => setActiveTab('fournisseurs-directs')}
          className={`px-4 py-2 font-medium text-sm border-b-2 transition-colors ${
            activeTab === 'fournisseurs-directs'
              ? 'border-indigo-600 text-indigo-600'
              : 'border-transparent text-slate-500 hover:text-slate-700'
          }`}
        >
          <Truck className="w-4 h-4 inline mr-2" />
          Fournisseurs Directs
        </button>
      </div>

      {/* Tab: Fournisseurs Directs */}
      {activeTab === 'fournisseurs-directs' && (
        <div className="space-y-6">
          {/* Info box */}
          <div className="bg-purple-50 border border-purple-200 rounded-lg p-4">
            <div className="flex items-start">
              <Truck className="w-5 h-5 text-purple-600 mr-3 mt-0.5" />
              <div>
                <p className="text-sm font-medium text-purple-800">Fournisseurs Directs par défaut</p>
                <p className="text-sm text-purple-600">
                  Cette liste est la base pour tous les nouveaux projets. Les enseignes peuvent personnaliser leurs propres désignations.
                </p>
              </div>
            </div>
          </div>
          
          {/* Add form */}
          <div className="bg-white rounded-lg border border-slate-200 p-4">
            <p className="text-sm font-medium text-slate-700 mb-3">Ajouter un fournisseur direct</p>
            <div className="flex flex-wrap gap-3">
              <input
                type="text"
                placeholder="Désignation (ex: Bureau de contrôle)"
                value={newFDDesignation}
                onChange={(e) => setNewFDDesignation(e.target.value)}
                onKeyDown={(e) => e.key === 'Enter' && handleAddFournisseurDirect()}
                className="flex-1 min-w-[250px] h-10 px-3 text-sm border border-slate-300 rounded-lg focus:border-purple-500 focus:outline-none"
              />
              <select
                value={newFDCategorie}
                onChange={(e) => setNewFDCategorie(e.target.value)}
                className="h-10 px-3 text-sm border border-slate-300 rounded-lg bg-white"
              >
                {categoriesFD.map(cat => (
                  <option key={cat.value} value={cat.value}>{cat.label}</option>
                ))}
              </select>
              <button
                onClick={handleAddFournisseurDirect}
                className="h-10 px-4 bg-purple-600 text-white rounded-lg text-sm font-medium hover:bg-purple-700 flex items-center gap-2"
              >
                <Plus className="w-4 h-4" />
                Ajouter
              </button>
            </div>
          </div>
          
          {/* List by category */}
          {categoriesFD.map(cat => {
            const items = baseFournisseursDirects.filter(fd => fd.categorie === cat.value);
            if (items.length === 0) return null;
            
            return (
              <div key={cat.value} className="bg-white rounded-lg border border-slate-200 overflow-hidden">
                <div className="bg-slate-50 px-4 py-3 border-b border-slate-200">
                  <h3 className="font-semibold text-slate-700">{cat.label}</h3>
                  <p className="text-xs text-slate-500">{items.length} élément{items.length > 1 ? 's' : ''}</p>
                </div>
                <div className="divide-y divide-slate-100">
                  {items.map((fd, idx) => (
                    <div key={fd.id} className="flex items-center px-4 py-3 hover:bg-slate-50">
                      <span className="w-8 text-sm text-slate-400 font-mono">{idx + 1}.</span>
                      <input
                        type="text"
                        defaultValue={fd.designation}
                        onBlur={(e) => {
                          if (e.target.value.trim() !== fd.designation) {
                            handleUpdateFournisseurDirect(fd.id, 'designation', e.target.value.trim());
                          }
                        }}
                        className="flex-1 h-9 px-3 text-sm border border-slate-200 rounded-lg focus:border-purple-500 focus:outline-none"
                      />
                      <button
                        onClick={() => handleDeleteFournisseurDirect(fd.id)}
                        className="ml-3 p-2 text-red-500 hover:bg-red-50 rounded-lg"
                      >
                        <Trash2 className="w-4 h-4" />
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
          
          {baseFournisseursDirects.length === 0 && (
            <div className="text-center py-12 bg-slate-50 rounded-lg">
              <Truck className="w-12 h-12 mx-auto mb-4 text-slate-300" />
              <p className="text-slate-500">Aucun fournisseur direct configuré</p>
              <p className="text-sm text-slate-400 mt-1">Ajoutez vos premiers fournisseurs directs ci-dessus</p>
            </div>
          )}
        </div>
      )}

      {activeTab === 'prestations' ? (
        <>
          {/* Info box */}
          <div className="bg-indigo-50 border border-indigo-200 rounded-lg p-4">
            <div className="flex items-start">
              <FileText className="w-5 h-5 text-indigo-600 mr-3 mt-0.5" />
              <div>
                <p className="text-sm font-medium text-indigo-800">Base de données MAAG</p>
                <p className="text-sm text-indigo-600">
                  Ces prestations servent de modèle pour tous vos devis. 
                  Les prix sont définis par enseigne dans leur fiche respective.
                </p>
              </div>
            </div>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
            <div className="bg-white rounded-lg border border-slate-200 p-4">
              <p className="text-2xl font-bold text-slate-900">
                {baseMaag.reduce((acc, lot) => {
                  const directCount = lot.prestations?.length || 0;
                  const sousLotsCount = (lot.sous_lots || []).reduce((a, sl) => a + (sl.prestations?.length || 0), 0);
                  return acc + directCount + sousLotsCount;
                }, 0)}
              </p>
              <p className="text-sm text-slate-500">Prestations totales</p>
            </div>
            <div className="bg-white rounded-lg border border-slate-200 p-4">
              <p className="text-2xl font-bold text-slate-900">18</p>
              <p className="text-sm text-slate-500">Lots MAAG</p>
            </div>
            <div className="bg-white rounded-lg border border-slate-200 p-4">
              <p className="text-2xl font-bold text-purple-600">
                {baseMaag.reduce((acc, lot) => acc + (lot.sous_lots?.length || 0), 0)}
              </p>
              <p className="text-sm text-slate-500">Sous-lots</p>
            </div>
            <div className="bg-white rounded-lg border border-slate-200 p-4">
              <p className="text-2xl font-bold text-indigo-600">
                {baseMaag.filter(lot => getPrestationCount(lot.lot_id) > 0).length}
              </p>
              <p className="text-sm text-slate-500">Lots renseignés</p>
            </div>
            <div className="bg-white rounded-lg border border-slate-200 p-4">
              <p className="text-2xl font-bold text-amber-600">
                {baseMaag.filter(lot => getPrestationCount(lot.lot_id) === 0).length}
              </p>
              <p className="text-sm text-slate-500">Lots vides</p>
            </div>
          </div>

          {/* Lots list */}
          <div className="bg-white rounded-xl border border-slate-200 overflow-hidden">
        {baseMaag.filter(lot => !lotFilter || lot.lot_id === lotFilter).map((lot) => {
          const totalPrestations = getPrestationCount(lot.lot_id);
          const sousLotsCount = lot.sous_lots?.length || 0;
          
          return (
          <div key={lot.lot_id} className="border-b border-slate-100 last:border-b-0">
            {/* Lot header */}
            <button
              onClick={() => toggleLot(lot.lot_id)}
              className="w-full flex items-center justify-between px-6 py-4 hover:bg-slate-50 transition-colors"
            >
              <div className="flex items-center">
                {expandedLots[lot.lot_id] ? (
                  <ChevronDown className="w-5 h-5 text-slate-400 mr-3" />
                ) : (
                  <ChevronRight className="w-5 h-5 text-slate-400 mr-3" />
                )}
                <span className="w-8 h-8 bg-indigo-100 rounded-lg flex items-center justify-center mr-3 text-sm font-bold text-indigo-600">
                  {lot.lot_id}
                </span>
                <span className="font-medium text-slate-900">{lot.lot_nom}</span>
              </div>
              <div className="flex items-center gap-3">
                {sousLotsCount > 0 && (
                  <span className="px-2 py-0.5 rounded-full text-xs font-medium bg-purple-100 text-purple-700">
                    {sousLotsCount} sous-lot{sousLotsCount > 1 ? 's' : ''}
                  </span>
                )}
                <span className={`px-2.5 py-0.5 rounded-full text-xs font-medium ${
                  totalPrestations > 0 
                    ? 'bg-indigo-100 text-indigo-700' 
                    : 'bg-slate-100 text-slate-500'
                }`}>
                  {totalPrestations} prestation{totalPrestations !== 1 ? 's' : ''}
                </span>
                <Button
                  size="sm"
                  variant="ghost"
                  onClick={(e) => {
                    e.stopPropagation();
                    openSousLotModal(lot.lot_id);
                  }}
                  className="text-purple-600 hover:text-purple-700 hover:bg-purple-50"
                  title="Ajouter un sous-lot"
                >
                  <FolderPlus className="w-4 h-4" />
                </Button>
                <Button
                  size="sm"
                  variant="ghost"
                  onClick={(e) => {
                    e.stopPropagation();
                    openGroupementsManager(lot.lot_id);
                  }}
                  className="text-emerald-600 hover:text-emerald-700 hover:bg-emerald-50"
                  title="Gérer les groupements de ce lot"
                  data-testid={`lot-groupements-btn-${lot.lot_id}`}
                >
                  <Package className="w-4 h-4" />
                </Button>
                <Button
                  size="sm"
                  variant="ghost"
                  onClick={(e) => {
                    e.stopPropagation();
                    openCreateModal(lot.lot_id);
                  }}
                  className="text-indigo-600 hover:text-indigo-700 hover:bg-indigo-50"
                  title="Ajouter une prestation"
                >
                  <Plus className="w-4 h-4" />
                </Button>
              </div>
            </button>

            {/* Sous-lots and Prestations */}
            {expandedLots[lot.lot_id] && (
              <div className="px-6 pb-4">
                {/* Sous-lots with drag and drop */}
                {lot.sous_lots && lot.sous_lots.length > 0 && (
                  <div className="mb-4 space-y-2">
                    <DndContext
                      sensors={sensors}
                      collisionDetection={closestCenter}
                      onDragEnd={(event) => handleDragEnd(event, lot.lot_id)}
                    >
                      <SortableContext
                        items={lot.sous_lots.map(sl => sl.id)}
                        strategy={verticalListSortingStrategy}
                      >
                        {lot.sous_lots.map(sousLot => (
                          <SortableSousLot
                            key={sousLot.id}
                            sousLot={sousLot}
                            lotId={lot.lot_id}
                            expandedSousLots={expandedSousLots}
                            toggleSousLot={toggleSousLot}
                            openCreateModal={openCreateModal}
                            openSousLotModal={openSousLotModal}
                            handleDeleteSousLot={handleDeleteSousLot}
                            selectedPrestations={selectedPrestations}
                            toggleSelectPrestation={toggleSelectPrestation}
                            openEditModal={openEditModal}
                            handleDelete={handleDelete}
                            openDuplicateModal={openDuplicateModal}
                          />
                        ))}
                      </SortableContext>
                    </DndContext>
                  </div>
                )}

                {/* Direct prestations (not in sous-lots) */}
                {lot.prestations?.length > 0 && (
                <div>
                  <div className="text-xs text-slate-500 uppercase mb-2 font-medium">Prestations directes</div>
                  <table className="w-full">
                  <thead>
                    <tr className="text-xs text-slate-500 uppercase">
                      <th className="w-10 py-2 px-2">
                        <input
                          type="checkbox"
                          checked={lot.prestations.every(p => selectedPrestations.has(p.id))}
                          onChange={() => selectAllInLot(lot.lot_id)}
                          className="w-4 h-4 rounded border-slate-300 text-indigo-600 focus:ring-indigo-500"
                        />
                      </th>
                      <th className="text-left py-2 px-2">Code</th>
                      <th className="text-left py-2 px-2">Désignation</th>
                      <th className="text-center py-2 px-2">Unité</th>
                      <th className="text-center py-2 px-2">Qté</th>
                      <th className="text-right py-2 px-2">Prix MAAG</th>
                      <th className="text-right py-2 px-2 w-24">Actions</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-slate-100">
                    {lot.prestations.map((prestation) => (
                      <tr key={prestation.id} className={`hover:bg-slate-50 ${selectedPrestations.has(prestation.id) ? 'bg-indigo-50' : ''}`}>
                        <td className="py-2 px-2">
                          <input
                            type="checkbox"
                            checked={selectedPrestations.has(prestation.id)}
                            onChange={() => toggleSelectPrestation(prestation.id)}
                            className="w-4 h-4 rounded border-slate-300 text-indigo-600 focus:ring-indigo-500"
                          />
                        </td>
                        <td className="py-2 px-2">
                          <span className="font-mono text-xs bg-slate-100 px-2 py-1 rounded">
                            {prestation.code}
                          </span>
                        </td>
                        <td className="py-2 px-2">
                          <p className="font-medium text-sm">{prestation.designation}</p>
                          {prestation.description && (
                            <p className="text-xs text-slate-400 mt-0.5 truncate max-w-xs" title={prestation.description}>
                              {prestation.description.length > 60 ? prestation.description.substring(0, 60) + '...' : prestation.description}
                            </p>
                          )}
                        </td>
                        <td className="py-2 px-2 text-center">
                          {inlineEditing?.id === prestation.id && inlineEditing?.field === 'unite' ? (
                            <div className="flex items-center gap-1">
                              <select
                                value={inlineEditing.value}
                                onChange={(e) => setInlineEditing({...inlineEditing, value: e.target.value})}
                                className="w-20 h-7 text-xs border border-indigo-300 rounded focus:ring-1 focus:ring-indigo-500"
                                autoFocus
                              >
                                {unites.map(u => <option key={u} value={u}>{u}</option>)}
                              </select>
                              <button onClick={() => saveInlineEdit(prestation.id, lot.lot_id)} className="p-1 text-green-600 hover:bg-green-50 rounded">
                                <Check className="w-3 h-3" />
                              </button>
                              <button onClick={cancelInlineEdit} className="p-1 text-slate-400 hover:bg-slate-100 rounded">
                                <X className="w-3 h-3" />
                              </button>
                            </div>
                          ) : (
                            <button 
                              onClick={() => startInlineEdit(prestation.id, 'unite', prestation.unite)}
                              className="text-xs bg-slate-200 px-2 py-0.5 rounded hover:bg-indigo-100 hover:text-indigo-700 transition-colors"
                            >
                              {prestation.unite}
                            </button>
                          )}
                        </td>
                        <td className="py-2 px-2 text-center">
                          {inlineEditing?.id === prestation.id && inlineEditing?.field === 'quantite_defaut' ? (
                            <div className="flex items-center gap-1 justify-center">
                              <input
                                type="number"
                                value={inlineEditing.value}
                                onChange={(e) => setInlineEditing({...inlineEditing, value: e.target.value})}
                                className="w-16 h-7 text-xs text-center border border-indigo-300 rounded focus:ring-1 focus:ring-indigo-500"
                                autoFocus
                              />
                              <button onClick={() => saveInlineEdit(prestation.id, lot.lot_id)} className="p-1 text-green-600 hover:bg-green-50 rounded">
                                <Check className="w-3 h-3" />
                              </button>
                              <button onClick={cancelInlineEdit} className="p-1 text-slate-400 hover:bg-slate-100 rounded">
                                <X className="w-3 h-3" />
                              </button>
                            </div>
                          ) : (
                            <button 
                              onClick={() => startInlineEdit(prestation.id, 'quantite_defaut', prestation.quantite_defaut || 0)}
                              className="text-sm hover:bg-indigo-100 hover:text-indigo-700 px-2 py-0.5 rounded transition-colors"
                            >
                              {prestation.quantite_defaut || 0}
                            </button>
                          )}
                        </td>
                        <td className="py-2 px-2 text-right">
                          {inlineEditing?.id === prestation.id && inlineEditing?.field === 'prix_maag' ? (
                            <div className="flex items-center gap-1 justify-end">
                              <input
                                type="number"
                                step="0.01"
                                value={inlineEditing.value}
                                onChange={(e) => setInlineEditing({...inlineEditing, value: e.target.value})}
                                className="w-20 h-7 text-xs text-right border border-indigo-300 rounded focus:ring-1 focus:ring-indigo-500"
                                autoFocus
                              />
                              <button onClick={() => saveInlineEdit(prestation.id, lot.lot_id)} className="p-1 text-green-600 hover:bg-green-50 rounded">
                                <Check className="w-3 h-3" />
                              </button>
                              <button onClick={cancelInlineEdit} className="p-1 text-slate-400 hover:bg-slate-100 rounded">
                                <X className="w-3 h-3" />
                              </button>
                            </div>
                          ) : (
                            <button 
                              onClick={() => startInlineEdit(prestation.id, 'prix_maag', prestation.prix_maag || 0)}
                              className="text-sm font-medium text-indigo-600 hover:bg-indigo-100 px-2 py-0.5 rounded transition-colors"
                            >
                              {(prestation.prix_maag || 0).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' })}
                            </button>
                          )}
                        </td>
                        <td className="py-2 px-2 text-right">
                          <div className="flex justify-end gap-1">
                            <button
                              onClick={() => openDuplicateModal(prestation, lot.lot_id)}
                              className="p-1.5 text-slate-400 hover:text-emerald-600 hover:bg-emerald-50 rounded"
                              title="Dupliquer cet article"
                              data-testid={`duplicate-${prestation.id}`}
                            >
                              <Copy className="w-4 h-4" />
                            </button>
                            <button
                              onClick={() => openEditModal(prestation, lot.lot_id)}
                              className="p-1.5 text-slate-400 hover:text-indigo-600 hover:bg-indigo-50 rounded"
                            >
                              <Edit2 className="w-4 h-4" />
                            </button>
                            <button
                              onClick={() => handleDelete(prestation.id)}
                              className="p-1.5 text-slate-400 hover:text-red-600 hover:bg-red-50 rounded"
                            >
                              <Trash2 className="w-4 h-4" />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                </div>
                )}

                {/* Empty state for lot - only if no sous-lots AND no direct prestations */}
                {(!lot.sous_lots || lot.sous_lots.length === 0) && (!lot.prestations || lot.prestations.length === 0) && (
                <div className="text-center py-6 bg-slate-50 rounded-lg border border-dashed border-slate-200">
                  <Package className="w-8 h-8 text-slate-300 mx-auto mb-2" />
                  <p className="text-sm text-slate-500">Aucune prestation dans ce lot</p>
                  <div className="flex justify-center gap-2 mt-2">
                    <Button
                      size="sm"
                      variant="ghost"
                      onClick={() => openSousLotModal(lot.lot_id)}
                      className="text-purple-600"
                    >
                      <FolderPlus className="w-4 h-4 mr-1" />
                      Créer un sous-lot
                    </Button>
                    <Button
                      size="sm"
                      variant="ghost"
                      onClick={() => openCreateModal(lot.lot_id)}
                      className="text-indigo-600"
                    >
                      <Plus className="w-4 h-4 mr-1" />
                      Ajouter une prestation
                    </Button>
                  </div>
                </div>
                )}
              </div>
            )}
          </div>
        )})}
          </div>
        </>
      ) : (
        /* Devis Types Tab - Simplified Version */
        <div className="space-y-6">
          {/* Info box */}
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
            <div className="flex items-start">
              <FileText className="w-5 h-5 text-blue-600 mr-3 mt-0.5" />
              <div>
                <p className="text-sm font-medium text-blue-800">Sélectionnez les prestations pour chaque devis type</p>
                <p className="text-sm text-blue-600">
                  Choisissez quelles prestations inclure dans chaque modèle de devis.
                </p>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
            {/* Liste des 4 types */}
            <div className="space-y-3">
              <h2 className="font-semibold text-slate-700">4 Modèles MAAG</h2>
              {TYPES_DEVIS.map(type => {
                const activePrestations = devisTypePrestations.filter(p => p.actif).length;
                const isSelected = selectedDevisType === type.code;
                
                return (
                  <button
                    key={type.code}
                    onClick={() => {
                      setSelectedDevisType(type.code);
                      loadDevisTypePrestations(type.code);
                    }}
                    className={`w-full p-4 rounded-lg border text-left transition-all ${
                      isSelected
                        ? 'border-indigo-500 bg-indigo-50 shadow-sm'
                        : 'border-slate-200 hover:border-slate-300 bg-white'
                    }`}
                  >
                    <div className="flex items-center gap-3">
                      <FileText className={`w-5 h-5 ${isSelected ? 'text-indigo-600' : 'text-slate-400'}`} />
                      <div className="flex-1">
                        <p className="font-medium text-slate-900">{type.nom}</p>
                        {isSelected && (
                          <p className="text-xs text-indigo-600">{activePrestations} prestation(s) sélectionnée(s)</p>
                        )}
                      </div>
                      <ChevronRight className={`w-4 h-4 transition-transform ${isSelected ? 'rotate-90 text-indigo-600' : 'text-slate-400'}`} />
                    </div>
                  </button>
                );
              })}
            </div>

            {/* Config du type sélectionné */}
            <div className="lg:col-span-3">
              {selectedDevisType ? (
                <div className="bg-white rounded-xl border border-slate-200 shadow-sm">
                  <div className="p-4 border-b border-slate-200 flex items-center justify-between">
                    <div>
                      <h2 className="text-lg font-semibold text-slate-900">
                        {TYPES_DEVIS.find(t => t.code === selectedDevisType)?.nom}
                      </h2>
                      <p className="text-sm text-slate-500">
                        {devisTypePrestations.filter(p => p.actif).length} prestations incluses
                      </p>
                    </div>
                    <button
                      onClick={() => {
                        setPrestationsToAdd(new Set(devisTypePrestations.filter(p => p.actif).map(p => p.id)));
                        setShowAddPrestationsModal(true);
                      }}
                      className="flex items-center px-4 py-2 bg-indigo-600 text-white rounded-lg text-sm font-medium hover:bg-indigo-700 transition-colors"
                    >
                      <Plus className="w-4 h-4 mr-2" />
                      Gérer les prestations
                    </button>
                  </div>

                  {loadingDevisTypes ? (
                    <div className="flex items-center justify-center h-64">
                      <Loader2 className="w-6 h-6 animate-spin text-indigo-600" />
                    </div>
                  ) : (
                    <div className="max-h-[500px] overflow-y-auto">
                      {/* Group by lot and show only active prestations */}
                      {LOTS_MAAG.map(lot => {
                        const lotPrestations = devisTypePrestations.filter(p => p.lot_id === lot.id && p.actif);
                        if (lotPrestations.length === 0) return null;
                        
                        return (
                          <div key={lot.id} className="border-b border-slate-100 last:border-b-0">
                            <div className="px-4 py-2 bg-slate-50">
                              <div className="flex items-center gap-2">
                                <span className="w-6 h-6 bg-indigo-100 rounded flex items-center justify-center text-xs font-bold text-indigo-600">
                                  {lot.id}
                                </span>
                                <span className="font-medium text-sm text-slate-700">{lot.nom}</span>
                                <span className="text-xs text-slate-500">({lotPrestations.length})</span>
                              </div>
                            </div>
                            <div className="divide-y divide-slate-50">
                              {lotPrestations.map(prestation => (
                                <div key={prestation.id} className="px-4 py-2 flex items-center justify-between hover:bg-slate-50">
                                  <div className="flex-1">
                                    <p className="text-sm font-medium text-slate-900">{prestation.designation}</p>
                                    <p className="text-xs text-slate-500">{prestation.unite} • Qté: {prestation.quantite_defaut}</p>
                                  </div>
                                  <button
                                    onClick={() => handleTogglePrestationGlobal(prestation.id, true)}
                                    className="p-1.5 text-slate-400 hover:text-red-600 hover:bg-red-50 rounded"
                                    title="Retirer du devis type"
                                  >
                                    <X className="w-4 h-4" />
                                  </button>
                                </div>
                              ))}
                            </div>
                          </div>
                        );
                      })}
                      
                      {/* Empty state */}
                      {devisTypePrestations.filter(p => p.actif).length === 0 && (
                        <div className="p-12 text-center">
                          <Package className="w-12 h-12 text-slate-300 mx-auto mb-4" />
                          <p className="text-slate-500 font-medium">Aucune prestation sélectionnée</p>
                          <p className="text-sm text-slate-400 mt-1">Cliquez sur "Gérer les prestations" pour en ajouter</p>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              ) : (
                <div className="bg-slate-50 rounded-xl border border-dashed border-slate-300 h-64 flex items-center justify-center">
                  <div className="text-center">
                    <FileText className="w-10 h-10 text-slate-300 mx-auto mb-3" />
                    <p className="text-slate-500 font-medium">Sélectionnez un devis type</p>
                    <p className="text-sm text-slate-400">pour voir et gérer ses prestations</p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Modal - Add prestations to devis type */}
      {showAddPrestationsModal && selectedDevisType && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-3xl max-h-[80vh] flex flex-col">
            <div className="p-4 border-b border-slate-200 flex items-center justify-between">
              <div>
                <h2 className="text-lg font-bold text-slate-900">
                  Sélectionner les prestations
                </h2>
                <p className="text-sm text-slate-500">
                  {TYPES_DEVIS.find(t => t.code === selectedDevisType)?.nom} • {prestationsToAdd.size} sélectionnée(s)
                </p>
              </div>
              <button onClick={() => setShowAddPrestationsModal(false)} className="p-2 hover:bg-slate-100 rounded-lg">
                <X className="w-5 h-5" />
              </button>
            </div>
            
            <div className="flex-1 overflow-y-auto">
              {LOTS_MAAG.map(lot => {
                const lotPrestations = baseMaag.find(l => l.lot_id === lot.id)?.prestations || [];
                if (lotPrestations.length === 0) return null;
                
                const allSelected = lotPrestations.every(p => prestationsToAdd.has(p.id));
                const someSelected = lotPrestations.some(p => prestationsToAdd.has(p.id));
                
                return (
                  <div key={lot.id} className="border-b border-slate-100">
                    <div 
                      className="px-4 py-3 bg-slate-50 flex items-center gap-3 cursor-pointer hover:bg-slate-100"
                      onClick={() => {
                        // Toggle all prestations in lot
                        const newSet = new Set(prestationsToAdd);
                        if (allSelected) {
                          lotPrestations.forEach(p => newSet.delete(p.id));
                        } else {
                          lotPrestations.forEach(p => newSet.add(p.id));
                        }
                        setPrestationsToAdd(newSet);
                      }}
                    >
                      <div className={`w-5 h-5 rounded flex items-center justify-center border-2 ${
                        allSelected ? 'bg-indigo-600 border-indigo-600' : someSelected ? 'bg-indigo-200 border-indigo-400' : 'border-slate-300'
                      }`}>
                        {allSelected && <Check className="w-3 h-3 text-white" />}
                        {someSelected && !allSelected && <div className="w-2 h-2 bg-indigo-600 rounded-sm" />}
                      </div>
                      <span className="w-7 h-7 bg-indigo-100 rounded flex items-center justify-center text-sm font-bold text-indigo-600">
                        {lot.id}
                      </span>
                      <span className="font-medium text-slate-900">{lot.nom}</span>
                      <span className="text-sm text-slate-500">
                        ({lotPrestations.filter(p => prestationsToAdd.has(p.id)).length}/{lotPrestations.length})
                      </span>
                    </div>
                    <div className="divide-y divide-slate-50">
                      {lotPrestations.map(prestation => (
                        <label
                          key={prestation.id}
                          className="flex items-center gap-3 px-4 py-2 hover:bg-indigo-50 cursor-pointer"
                        >
                          <input
                            type="checkbox"
                            checked={prestationsToAdd.has(prestation.id)}
                            onChange={() => {
                              const newSet = new Set(prestationsToAdd);
                              if (newSet.has(prestation.id)) {
                                newSet.delete(prestation.id);
                              } else {
                                newSet.add(prestation.id);
                              }
                              setPrestationsToAdd(newSet);
                            }}
                            className="w-4 h-4 rounded border-slate-300 text-indigo-600 focus:ring-indigo-500"
                          />
                          <div className="flex-1">
                            <p className="text-sm font-medium text-slate-900">{prestation.designation}</p>
                            <p className="text-xs text-slate-500">
                              {prestation.code} • {prestation.unite} • {(prestation.prix_maag || 0).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' })}
                            </p>
                          </div>
                        </label>
                      ))}
                    </div>
                  </div>
                );
              })}
            </div>
            
            <div className="p-4 border-t border-slate-200 bg-slate-50 flex items-center justify-between">
              <p className="text-sm text-slate-600">
                {prestationsToAdd.size} prestation(s) sélectionnée(s)
              </p>
              <div className="flex gap-3">
                <button
                  onClick={() => setShowAddPrestationsModal(false)}
                  className="px-4 py-2 border border-slate-300 text-slate-700 rounded-lg font-medium hover:bg-white"
                >
                  Annuler
                </button>
                <button
                  onClick={async () => {
                    setAddingPrestations(true);
                    try {
                      // Update each prestation's active status
                      for (const prestation of devisTypePrestations) {
                        const shouldBeActive = prestationsToAdd.has(prestation.id);
                        if (prestation.actif !== shouldBeActive) {
                          await handleTogglePrestationGlobal(prestation.id, prestation.actif, true);
                        }
                      }
                      toast.success('Prestations mises à jour');
                      setShowAddPrestationsModal(false);
                      loadDevisTypePrestations(selectedDevisType);
                    } catch (e) {
                      toast.error('Erreur lors de la mise à jour');
                    } finally {
                      setAddingPrestations(false);
                    }
                  }}
                  disabled={addingPrestations}
                  className="px-4 py-2 bg-indigo-600 text-white rounded-lg font-medium hover:bg-indigo-700 disabled:opacity-50 flex items-center gap-2"
                >
                  {addingPrestations ? (
                    <>
                      <Loader2 className="w-4 h-4 animate-spin" />
                      Enregistrement...
                    </>
                  ) : (
                    <>
                      <Check className="w-4 h-4" />
                      Enregistrer
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl shadow-2xl max-w-lg w-full p-6 max-h-[90vh] overflow-y-auto">
            <div className="flex items-center justify-between mb-6">
              <h2 className="text-lg font-bold text-slate-900">
                {editingPrestation ? 'Modifier la prestation' : 'Nouvelle prestation'}
              </h2>
              <button onClick={() => setShowModal(false)} className="p-2 hover:bg-slate-100 rounded-lg">
                <X className="w-5 h-5 text-slate-500" />
              </button>
            </div>

            <form onSubmit={handleSubmit} className="space-y-4">
              {/* Lot selection */}
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1">Lot *</label>
                <select
                  value={formData.lot_id}
                  onChange={(e) => setFormData({...formData, lot_id: e.target.value, sous_lot_id: ''})}
                  disabled={!!editingPrestation}
                  className="w-full h-10 px-3 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 disabled:bg-slate-100"
                >
                  {lots.map(lot => (
                    <option key={lot.id} value={lot.id}>
                      {lot.id} - {lot.nom}
                    </option>
                  ))}
                </select>
              </div>

              {/* Sous-lot selection (optional) */}
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1">
                  <Layers className="w-4 h-4 inline mr-1 text-purple-600" />
                  Sous-lot (optionnel)
                </label>
                <select
                  value={formData.sous_lot_id || ''}
                  onChange={(e) => setFormData({...formData, sous_lot_id: e.target.value})}
                  className="w-full h-10 px-3 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
                >
                  <option value="">-- Aucun sous-lot (prestation directe) --</option>
                  {(baseMaag.find(l => l.lot_id === formData.lot_id)?.sous_lots || []).map(sl => (
                    <option key={sl.id} value={sl.id}>
                      {sl.nom}
                    </option>
                  ))}
                </select>
                <p className="text-xs text-slate-500 mt-1">
                  Permet de regrouper les prestations sous un titre (ex: "Tableau électrique")
                </p>
              </div>

              {/* Assignation */}
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1">
                  Assignation <span className="text-slate-400 font-normal">(où l'article est visible)</span>
                </label>
                <select
                  value={formData.enseigne_id}
                  onChange={(e) => setFormData({...formData, enseigne_id: e.target.value})}
                  className="w-full h-10 px-3 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 bg-white"
                  data-testid="assignation-select"
                >
                  <option value="">MAAG (commun à toutes les enseignes)</option>
                  {enseignesList.map(ens => (
                    <option key={ens.id} value={ens.id}>Spécifique à : {ens.nom}</option>
                  ))}
                </select>
                <p className="text-xs text-slate-500 mt-1">
                  {formData.enseigne_id
                    ? "Visible uniquement dans les devis de cette enseigne"
                    : "Visible dans tous les devis, toutes enseignes confondues"}
                </p>
              </div>

              {/* Auto-generated code preview (create mode only) */}
              {!editingPrestation && (
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-1">Code (généré automatiquement)</label>
                  <div className="h-10 px-3 flex items-center bg-slate-50 border border-slate-200 rounded-lg font-mono text-sm text-slate-700" data-testid="preview-code">
                    {previewCode || <span className="text-slate-400 italic">— en attente —</span>}
                  </div>
                </div>
              )}
              {editingPrestation && (
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-1">Code</label>
                  <div className="h-10 px-3 flex items-center bg-slate-100 border border-slate-200 rounded-lg font-mono text-sm text-slate-500">
                    {formData.code}
                  </div>
                </div>
              )}

              {/* Désignation */}
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1">Désignation *</label>
                <Input
                  type="text"
                  value={formData.designation}
                  onChange={(e) => setFormData({...formData, designation: e.target.value})}
                  placeholder="Pilotage général chantier"
                  required
                />
              </div>

              {/* Description */}
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1">Description détaillée *</label>
                <textarea
                  value={formData.description}
                  onChange={(e) => setFormData({...formData, description: e.target.value})}
                  rows={3}
                  placeholder="Description professionnelle de la prestation..."
                  className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                  required
                />
                {/* IA : génère TITRE + DESCRIPTION — type MAAG (générique) */}
                <div className="mt-2">
                  <AIDescriptionButton
                    sourceText={`${formData.designation || ''}\n${formData.description || ''}`.trim()}
                    type="MAAG"
                    lot={LOTS_MAAG.find(l => l.id === formData.lot_id)?.nom || ''}
                    onResult={({ titre, description }) =>
                      setFormData(prev => ({ ...prev, designation: titre, description }))
                    }
                  />
                </div>
              </div>

              {/* Unité et Quantité */}
              <div className="grid grid-cols-3 gap-4">
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-1">Unité *</label>
                  <select
                    value={formData.unite}
                    onChange={(e) => setFormData({...formData, unite: e.target.value})}
                    className="w-full h-10 px-3 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                  >
                    {unites.map(u => (
                      <option key={u} value={u}>{u}</option>
                    ))}
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-1">Qté par défaut</label>
                  <Input
                    type="number"
                    step="0.01"
                    min="0"
                    value={formData.quantite_defaut}
                    onChange={(e) => setFormData({...formData, quantite_defaut: parseFloat(e.target.value) || 0})}
                  />
                  <p className="text-[10px] text-slate-400 mt-0.5">0 par défaut, 1 si FORFAIT</p>
                </div>
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-1">Prix MAAG (€)</label>
                  <Input
                    type="number"
                    step="0.01"
                    min="0"
                    value={formData.prix_maag}
                    onChange={(e) => setFormData({...formData, prix_maag: parseFloat(e.target.value) || 0})}
                  />
                  <p className="text-[10px] text-slate-400 mt-0.5">Prix de référence</p>
                </div>
              </div>

              {/* Actions */}
              <div className="flex flex-wrap justify-end gap-2 pt-4">
                <Button type="button" variant="outline" onClick={() => setShowModal(false)} disabled={savingPrestation}>
                  Annuler
                </Button>
                {!editingPrestation && (
                  <Button
                    type="button"
                    variant="outline"
                    className="border-emerald-600 text-emerald-700 hover:bg-emerald-50"
                    onClick={(e) => handleSubmit(e, true)}
                    disabled={savingPrestation}
                    data-testid="save-and-add-another-btn"
                  >
                    {savingPrestation ? (
                      <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                    ) : (
                      <Plus className="w-4 h-4 mr-2" />
                    )}
                    Enregistrer & ajouter un autre
                  </Button>
                )}
                <Button type="submit" className="bg-indigo-600 hover:bg-indigo-700" disabled={savingPrestation}>
                  {savingPrestation ? (
                    <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                  ) : (
                    <Save className="w-4 h-4 mr-2" />
                  )}
                  {editingPrestation ? 'Mettre à jour' : 'Ajouter & fermer'}
                </Button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Modal for Sous-lot creation/editing */}
      {showSousLotModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl shadow-2xl max-w-md w-full p-6">
            <div className="flex items-center justify-between mb-6">
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 bg-purple-100 rounded-lg flex items-center justify-center">
                  <Layers className="w-5 h-5 text-purple-600" />
                </div>
                <h2 className="text-lg font-bold text-slate-900">
                  {editingSousLot ? 'Modifier le sous-lot' : 'Nouveau sous-lot'}
                </h2>
              </div>
              <button onClick={() => setShowSousLotModal(false)} className="p-2 hover:bg-slate-100 rounded-lg">
                <X className="w-5 h-5 text-slate-500" />
              </button>
            </div>

            <form onSubmit={handleSousLotSubmit} className="space-y-4">
              {/* Lot parent */}
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1">Lot parent</label>
                <div className="px-3 py-2 bg-slate-100 rounded-lg text-slate-700">
                  {sousLotFormData.lot_id} - {lots.find(l => l.id === sousLotFormData.lot_id)?.nom || ''}
                </div>
              </div>

              {/* Nom du sous-lot */}
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1">Nom du sous-lot *</label>
                <Input
                  type="text"
                  value={sousLotFormData.nom}
                  onChange={(e) => setSousLotFormData({...sousLotFormData, nom: e.target.value})}
                  placeholder="Ex: Tableau électrique, Prises et interrupteurs..."
                  required
                />
                <p className="text-xs text-slate-500 mt-1">
                  Ce nom apparaîtra en gras/surligné dans le devis PDF
                </p>
              </div>

              {/* Ordre */}
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1">Ordre d'affichage</label>
                <Input
                  type="number"
                  min="0"
                  value={sousLotFormData.ordre}
                  onChange={(e) => setSousLotFormData({...sousLotFormData, ordre: parseInt(e.target.value) || 0})}
                />
                <p className="text-xs text-slate-500 mt-1">
                  Les sous-lots sont triés par ordre croissant
                </p>
              </div>

              {/* Actions */}
              <div className="flex justify-end gap-3 pt-4">
                <Button type="button" variant="outline" onClick={() => setShowSousLotModal(false)}>
                  Annuler
                </Button>
                <Button type="submit" className="bg-purple-600 hover:bg-purple-700">
                  <Save className="w-4 h-4 mr-2" />
                  {editingSousLot ? 'Mettre à jour' : 'Créer'}
                </Button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Sous-lots par défaut manager modal */}
      {showSousLotsManager && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50" data-testid="sous-lots-manager-modal">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-2xl mx-4 max-h-[90vh] flex flex-col">
            <div className="flex items-center justify-between p-5 border-b">
              <div>
                <h2 className="text-lg font-bold text-slate-900 flex items-center gap-2">
                  <Package className="w-5 h-5 text-blue-600" /> Sous-lots par défaut
                </h2>
                <p className="text-xs text-slate-500">Liste pré-remplie dans le dropdown quand vous créez une prestation ou un groupement.</p>
              </div>
              <button onClick={() => setShowSousLotsManager(false)} className="text-slate-400 hover:text-slate-600">
                <X className="w-5 h-5" />
              </button>
            </div>
            <div className="p-5 border-b">
              <label className="block text-sm font-medium text-slate-700 mb-1">Lot :</label>
              <select
                value={sousLotsManagerLotId}
                onChange={(e) => setSousLotsManagerLotId(e.target.value)}
                className="w-full h-10 px-3 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                data-testid="sous-lots-manager-lot-select"
              >
                {[
                  {id: '1', nom: 'PILOTAGE DES INTERVENANTS DIRECTS / BUREAU D\'ETUDE'},
                  {id: '2', nom: 'HONORAIRES'},
                  {id: '3', nom: 'INSTALLATION CHANTIER'},
                  {id: '4', nom: 'DEPOSE / DEMOLITION'},
                  {id: '5', nom: 'MACONNERIE / PLATRERIE / PLAFOND'},
                  {id: '6', nom: 'MENUISERIE'},
                  {id: '7', nom: 'SOLS / FAIENCE'},
                  {id: '8', nom: 'METALLERIE / SERRURERIE'},
                  {id: '9', nom: 'PEINTURE'},
                  {id: '10', nom: 'AGENCEMENT / MOBILIER'},
                  {id: '11', nom: 'VITRERIE'},
                  {id: '12', nom: 'ELECTRICITE'},
                  {id: '13', nom: 'CLIMATISATION - RAC - VMC'},
                  {id: '14', nom: 'PLOMBERIE SANITAIRES'},
                  {id: '15', nom: 'NETTOYAGE'},
                ].map(lot => (
                  <option key={lot.id} value={lot.id}>Lot {lot.id} – {lot.nom}</option>
                ))}
              </select>
            </div>
            <div className="flex-1 overflow-y-auto p-5 space-y-2">
              {sousLotsManagerLoading ? (
                <p className="text-sm text-slate-500 italic">Chargement…</p>
              ) : sousLotsManagerList.length === 0 ? (
                <p className="text-sm text-slate-500 italic">Aucun sous-lot défini pour ce lot. Ajoute-en un ci-dessous.</p>
              ) : (
                sousLotsManagerList.map((sl) => (
                  <div key={sl.id} className="flex items-center gap-2 p-2 bg-slate-50 border border-slate-200 rounded">
                    <span className="w-8 text-xs text-slate-400 font-mono">#{sl.ordre + 1}</span>
                    <input
                      type="text"
                      defaultValue={sl.nom}
                      onBlur={(e) => { const nv = e.target.value.trim().toUpperCase(); if (nv && nv !== sl.nom) updateSousLotTemplate(sl.id, nv); }}
                      onKeyDown={(e) => { if (e.key === 'Enter') e.target.blur(); }}
                      className="flex-1 h-8 px-2 text-sm border border-slate-300 rounded uppercase"
                      data-testid={`sous-lot-edit-${sl.id}`}
                    />
                    <button
                      onClick={() => deleteSousLotTemplate(sl.id)}
                      className="text-slate-400 hover:text-red-600 p-1"
                      title="Supprimer"
                    >
                      <Trash2 className="w-4 h-4" />
                    </button>
                  </div>
                ))
              )}
            </div>
            <div className="p-5 border-t flex items-center gap-2">
              <input
                type="text"
                value={sousLotsManagerNew}
                onChange={(e) => setSousLotsManagerNew(e.target.value.toUpperCase())}
                onKeyDown={(e) => { if (e.key === 'Enter') addSousLotTemplate(); }}
                placeholder="NOM DU NOUVEAU SOUS-LOT..."
                className="flex-1 h-10 px-3 border border-slate-300 rounded-lg uppercase"
                data-testid="sous-lots-manager-new-input"
              />
              <Button onClick={addSousLotTemplate} className="bg-blue-600 hover:bg-blue-700" data-testid="sous-lots-manager-add-btn">
                <Plus className="w-4 h-4 mr-1" />
                Ajouter
              </Button>
            </div>
          </div>
        </div>
      )}

      {/* Groupements Manager Modal */}
      {showGroupementsManager && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" onClick={() => setShowGroupementsManager(false)}>
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-4xl max-h-[90vh] flex flex-col" onClick={(e) => e.stopPropagation()} data-testid="groupements-manager-modal">
            <div className="flex items-center justify-between p-5 border-b border-slate-200">
              <div>
                <h3 className="text-xl font-bold text-slate-900 flex items-center gap-2">
                  <Package className="w-6 h-6 text-emerald-600" />
                  Groupements du Lot {groupementsManagerLotId}
                </h3>
                <p className="text-sm text-slate-500 mt-1">
                  {lots.find(l => l.id === groupementsManagerLotId)?.nom || ''} — {groupementsList.length} groupement{groupementsList.length !== 1 ? 's' : ''}
                </p>
              </div>
              <div className="flex items-center gap-2">
                <Button
                  onClick={() => setEditingGroupement({
                    id: null,
                    nom: '',
                    description: '',
                    lot_id: groupementsManagerLotId,
                    sous_lot_nom: '',
                    sous_sous_lot_nom: '',
                    enseigne_id: null,
                    lignes: [{ designation: '', unite: 'U', quantite: 1, prix_unitaire: 0 }],
                  })}
                  className="bg-emerald-600 hover:bg-emerald-700 text-white"
                  data-testid="groupement-new-btn"
                >
                  <Plus className="w-4 h-4 mr-1" /> Nouveau
                </Button>
                <button onClick={() => setShowGroupementsManager(false)} className="p-2 hover:bg-slate-100 rounded-lg">
                  <X className="w-5 h-5 text-slate-500" />
                </button>
              </div>
            </div>

            <div className="flex-1 overflow-y-auto p-5 space-y-3">
              {groupementsLoading ? (
                <div className="flex items-center justify-center py-12"><Loader2 className="w-6 h-6 animate-spin text-emerald-600" /></div>
              ) : groupementsList.length === 0 ? (
                <div className="text-center py-12">
                  <Package className="w-12 h-12 text-slate-300 mx-auto mb-3" />
                  <p className="text-slate-500">Aucun groupement pour ce lot</p>
                  <p className="text-xs text-slate-400 mt-1">Créez-en un via le bouton "Nouveau" en haut à droite</p>
                </div>
              ) : (
                Object.entries(
                  groupementsList.reduce((acc, g) => {
                    const key = g.sous_lot_nom || '(sans sous-lot)';
                    if (!acc[key]) acc[key] = [];
                    acc[key].push(g);
                    return acc;
                  }, {})
                ).sort(([a], [b]) => a.localeCompare(b)).map(([sousLot, items]) => (
                  <div key={sousLot} className="space-y-2">
                    <div className="text-xs font-bold text-slate-500 uppercase tracking-wide px-2 py-1 bg-slate-50 rounded">
                      {sousLot} · {items.length}
                    </div>
                    {items.map((g) => {
                      const total = (g.lignes || []).reduce((s, l) => s + (l.quantite || 0) * (l.prix_unitaire || 0), 0);
                      const isExpanded = expandedGroupements[g.id];
                      return (
                        <div key={g.id} className="border border-slate-200 rounded-lg overflow-hidden">
                          <div className="flex items-center justify-between p-3 hover:bg-slate-50">
                            <button
                              className="flex-1 flex items-center gap-2 text-left"
                              onClick={() => setExpandedGroupements(prev => ({ ...prev, [g.id]: !prev[g.id] }))}
                            >
                              {isExpanded ? <ChevronDown className="w-4 h-4 text-slate-400" /> : <ChevronRight className="w-4 h-4 text-slate-400" />}
                              <div>
                                <div className="font-medium text-slate-900">{g.nom}</div>
                                {g.sous_sous_lot_nom && <div className="text-xs text-slate-500">└ {g.sous_sous_lot_nom}</div>}
                              </div>
                            </button>
                            <div className="flex items-center gap-2">
                              <span className="text-sm text-slate-600">{(g.lignes || []).length} lignes · {total.toFixed(0)} €</span>
                              {g.enseigne_id && <span className="px-2 py-0.5 rounded-full text-xs bg-purple-100 text-purple-700">Enseigne</span>}
                              <button onClick={() => setEditingGroupement(JSON.parse(JSON.stringify(g)))} className="p-1.5 text-indigo-600 hover:bg-indigo-50 rounded" title="Éditer">
                                <Edit2 className="w-4 h-4" />
                              </button>
                              <button onClick={() => duplicateGroupement(g)} className="p-1.5 text-slate-600 hover:bg-slate-100 rounded" title="Dupliquer">
                                <Copy className="w-4 h-4" />
                              </button>
                              <button onClick={() => deleteGroupement(g.id)} className="p-1.5 text-red-600 hover:bg-red-50 rounded" title="Supprimer">
                                <Trash2 className="w-4 h-4" />
                              </button>
                            </div>
                          </div>
                          {isExpanded && (
                            <div className="px-3 pb-3 space-y-1 bg-slate-50 border-t border-slate-200">
                              {(g.lignes || []).map((l, i) => (
                                <div key={i} className="flex items-center justify-between text-sm py-1">
                                  <span className="text-slate-700">• {l.designation || l.description}</span>
                                  <span className="text-slate-500 tabular-nums whitespace-nowrap ml-3">
                                    {l.quantite} {l.unite} × {(l.prix_unitaire || 0).toFixed(2)} € = {((l.quantite || 0) * (l.prix_unitaire || 0)).toFixed(2)} €
                                  </span>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
      )}

      {/* Groupement Edit/Create Modal */}
      {editingGroupement && (
        <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-[60] p-4" onClick={() => setEditingGroupement(null)}>
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-3xl max-h-[90vh] flex flex-col" onClick={(e) => e.stopPropagation()} data-testid="groupement-edit-modal">
            <div className="flex items-center justify-between p-5 border-b border-slate-200">
              <h3 className="text-lg font-bold text-slate-900">
                {editingGroupement.id ? 'Modifier le groupement' : 'Nouveau groupement'}
              </h3>
              <button onClick={() => setEditingGroupement(null)} className="p-2 hover:bg-slate-100 rounded-lg">
                <X className="w-5 h-5 text-slate-500" />
              </button>
            </div>
            <div className="flex-1 overflow-y-auto p-5 space-y-4">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-1">Nom *</label>
                  <input
                    type="text"
                    value={editingGroupement.nom}
                    onChange={(e) => setEditingGroupement({ ...editingGroupement, nom: e.target.value })}
                    className="w-full h-10 px-3 border border-slate-300 rounded-lg"
                    placeholder="Ex: Caisse ADOPT"
                    data-testid="groupement-edit-nom"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-1">Sous-lot</label>
                  <input
                    type="text"
                    value={editingGroupement.sous_lot_nom || ''}
                    onChange={(e) => setEditingGroupement({ ...editingGroupement, sous_lot_nom: e.target.value })}
                    className="w-full h-10 px-3 border border-slate-300 rounded-lg"
                    placeholder="Ex: PREPARATION"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-1">Sous-sous-lot</label>
                  <input
                    type="text"
                    value={editingGroupement.sous_sous_lot_nom || ''}
                    onChange={(e) => setEditingGroupement({ ...editingGroupement, sous_sous_lot_nom: e.target.value })}
                    className="w-full h-10 px-3 border border-slate-300 rounded-lg"
                    placeholder="Ex: Alim par zone"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-1">Description</label>
                  <input
                    type="text"
                    value={editingGroupement.description || ''}
                    onChange={(e) => setEditingGroupement({ ...editingGroupement, description: e.target.value })}
                    className="w-full h-10 px-3 border border-slate-300 rounded-lg"
                  />
                </div>
              </div>

              <div>
                <div className="flex items-center justify-between mb-2">
                  <label className="block text-sm font-medium text-slate-700">Lignes ({(editingGroupement.lignes || []).length})</label>
                  <Button
                    size="sm"
                    onClick={() => setEditingGroupement({
                      ...editingGroupement,
                      lignes: [...(editingGroupement.lignes || []), { designation: '', unite: 'U', quantite: 1, prix_unitaire: 0 }],
                    })}
                    className="bg-slate-100 text-slate-700 hover:bg-slate-200"
                  >
                    <Plus className="w-4 h-4 mr-1" /> Ligne
                  </Button>
                </div>
                <div className="space-y-2">
                  {(editingGroupement.lignes || []).map((l, i) => (
                    <div key={i} className="grid grid-cols-12 gap-2 items-center">
                      <input
                        type="text"
                        value={l.designation || l.description || ''}
                        onChange={(e) => {
                          const lignes = [...editingGroupement.lignes];
                          lignes[i] = { ...lignes[i], designation: e.target.value };
                          setEditingGroupement({ ...editingGroupement, lignes });
                        }}
                        className="col-span-5 h-9 px-2 border border-slate-300 rounded text-sm"
                        placeholder="Désignation"
                      />
                      <input
                        type="text"
                        value={l.unite}
                        onChange={(e) => {
                          const lignes = [...editingGroupement.lignes];
                          lignes[i] = { ...lignes[i], unite: e.target.value };
                          setEditingGroupement({ ...editingGroupement, lignes });
                        }}
                        className="col-span-1 h-9 px-2 border border-slate-300 rounded text-sm text-center"
                        placeholder="U"
                      />
                      <input
                        type="number"
                        value={l.quantite}
                        onChange={(e) => {
                          const lignes = [...editingGroupement.lignes];
                          lignes[i] = { ...lignes[i], quantite: parseFloat(e.target.value) || 0 };
                          setEditingGroupement({ ...editingGroupement, lignes });
                        }}
                        className="col-span-2 h-9 px-2 border border-slate-300 rounded text-sm text-right"
                        placeholder="Qté"
                      />
                      <input
                        type="number"
                        value={l.prix_unitaire}
                        onChange={(e) => {
                          const lignes = [...editingGroupement.lignes];
                          lignes[i] = { ...lignes[i], prix_unitaire: parseFloat(e.target.value) || 0 };
                          setEditingGroupement({ ...editingGroupement, lignes });
                        }}
                        className="col-span-3 h-9 px-2 border border-slate-300 rounded text-sm text-right"
                        placeholder="PU €"
                      />
                      <button
                        onClick={() => {
                          const lignes = editingGroupement.lignes.filter((_, idx) => idx !== i);
                          setEditingGroupement({ ...editingGroupement, lignes });
                        }}
                        className="col-span-1 p-1.5 text-red-600 hover:bg-red-50 rounded"
                      >
                        <Trash2 className="w-4 h-4" />
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="flex items-center justify-end gap-2 p-5 border-t border-slate-200 bg-slate-50 rounded-b-xl">
              <Button variant="outline" onClick={() => setEditingGroupement(null)}>Annuler</Button>
              <Button
                onClick={async () => {
                  const ok = await saveGroupement(editingGroupement);
                  if (ok) setEditingGroupement(null);
                }}
                className="bg-emerald-600 hover:bg-emerald-700 text-white"
                data-testid="groupement-save-btn"
              >
                <Save className="w-4 h-4 mr-1" /> Enregistrer
              </Button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BaseMaagPage;
